import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function Differentiator() {
  const badPoints = ['Información contradictoria que te confunde más', 'Horas perdidas sin saber qué es confiable', 'Consejos genéricos que no aplican a tu caso', 'Sin estructura: un dato acá, otro allá', 'Te sentís más perdido/a después de buscar', 'Nadie te responde cuando tenés dudas'];
  const goodPoints = ['Todo verificado, organizado y listo para usar', 'Ahorrás meses de búsqueda y prueba-error', 'Estrategias adaptadas a la vida real con diabetes', 'Sistema paso a paso: sabés qué hacer cada día', 'Confianza desde el primer día', 'Comunidad de apoyo + masterclass incluida'];
  return <section className="py-20 px-4 bg-white border-l-8 border-[#1B4332]" data-id="element-66">
      <div className="max-w-6xl mx-auto" data-id="element-67">
        <div className="text-center mb-12" data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332]" data-id="element-69">
            ¿Por Qué Pagar Por Esto Si Hay Información Gratis en Google?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-70">
          {/* Left Column - The Bad Way */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50/30 p-8 rounded-2xl border border-red-100" data-id="element-71">
            <h3 className="text-xl font-bold text-red-800 mb-6 flex items-center gap-2" data-id="element-72">
              <X className="w-6 h-6" data-id="element-73" /> Buscar por tu cuenta
            </h3>
            <ul className="space-y-4" data-id="element-74">
              {badPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-[#1C1917]/80" data-id="element-75">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-76" />
                  <span data-id="element-77">{point}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Column - The Good Way */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#E6F4EA]/50 p-8 rounded-2xl border border-[#86EFAC]" data-id="element-78">
            <h3 className="text-xl font-bold text-[#1B4332] mb-6 flex items-center gap-2" data-id="element-79">
              <Check className="w-6 h-6" data-id="element-80" /> Con el Pack de Guías Prácticas
            </h3>
            <ul className="space-y-4" data-id="element-81">
              {goodPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-[#1C1917]" data-id="element-82">
                  <Check className="w-5 h-5 text-[#1B4332] flex-shrink-0 mt-0.5" data-id="element-83" />
                  <span className="font-medium" data-id="element-84">{point}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mt-12 text-center" data-id="element-85">
          <p className="text-xl font-medium text-[#1B4332]" data-id="element-86">
            La información gratis te da datos sueltos.{' '}
            <br className="hidden md:block" data-id="element-87" />
            <span className="font-bold" data-id="element-88">
              Este pack te da un SISTEMA completo para vivir mejor.
            </span>
          </p>
        </div>
      </div>
    </section>;
}